import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const ArrowRightIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { d: "m11.586 9.002-3.293 3.3A1.003 1.003 0 0 0 9.003 14a1 1 0 0 0 .704-.281l5-5.01a1.003 1.003 0 0 0 0-1.417l-5-5.01a.999.999 0 0 0-1.695.711c-.002.263.099.516.281.705l3.293 3.3H2A.999.999 0 0 0 1 8a1.003 1.003 0 0 0 1 1.002h9.586Z", fill: "currentColor" })));
});
ArrowRightIcon.displayName = 'ArrowRightIcon';
export default ArrowRightIcon;
